import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import AccountMenu from "./AccountMenu";
import CorticaLogo from "./CorticaLogo";
import MenuItems from "./MenuItems";
import { NavItem } from "./navItems";
import Sidebar, { DrawerHeader, drawerWidth } from "./Sidebar";
import { SidebarProvider } from "./SidebarContext";

// Below md, BloomABA has no layout at all; caregivers are mostly on phones, so
// we swap the permanent drawer for a top bar + temporary drawer.
const MobileNav = ({ navItems }: { navItems: NavItem[] }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const close = () => setMobileOpen(false);

  return (
    <>
      <AppBar
        position="sticky"
        color="inherit"
        elevation={0}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            onClick={() => setMobileOpen(true)}
            aria-label="Open navigation"
            sx={{ mr: 1 }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ width: 120 }}>
            <CorticaLogo />
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={close}
        ModalProps={{ keepMounted: true }}
        sx={{ "& .MuiDrawer-paper": { width: drawerWidth, maxWidth: "85vw" } }}
      >
        <DrawerHeader sx={{ justifyContent: "flex-start", p: 2 }}>
          <Box sx={{ width: 148, maxWidth: 148, height: "auto", ml: 0.5 }}>
            <CorticaLogo />
          </Box>
        </DrawerHeader>
        <Divider />
        <MenuItems items={navItems} open onNavigate={close} />
        <Box sx={{ flexGrow: 1 }} />
        <Divider />
        <AccountMenu open />
      </Drawer>
    </>
  );
};

const AppShell = ({ navItems }: { navItems: NavItem[] }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <SidebarProvider>
      <Box
        sx={{
          display: "flex",
          flexDirection: isDesktop ? "row" : "column",
          flex: 1,
          minHeight: 0,
        }}
      >
        {isDesktop ? (
          <Sidebar navItems={navItems} />
        ) : (
          <MobileNav navItems={navItems} />
        )}
        <Box
          component="main"
          sx={{ flexGrow: 1, minWidth: 0, overflowY: "auto" }}
        >
          <Outlet />
        </Box>
      </Box>
    </SidebarProvider>
  );
};

export default AppShell;
